// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as PaymentBody$OrcaPaymentPage from "../Utilities/PaymentBody.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "../Context/PaymentTypeContext.bs.js";
import * as EventListenerManager$OrcaPaymentPage from "../Utilities/EventListenerManager.bs.js";

function PayNowButton$Loader(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  return React.createElement("div", {
              className: "w-8 h-8 animate-spin",
              style: {
                color: match.themeObj.colorTextSecondary
              }
            }, React.createElement(Icon$OrcaPaymentPage.make, {
                  name: "loader",
                  size: 32
                }));
}

var Loader = {
  make: PayNowButton$Loader
};

function PayNowButton(props) {
  var label = props.label;
  var onClickHandler = props.onClickHandler;
  var match = React.useState(function () {
        return false;
      });
  var setShowLoader = match[1];
  var match$1 = React.useState(function () {
        return false;
      });
  var setIsPayNowButtonDisable = match$1[1];
  var isPayNowButtonDisable = match$1[0];
  var match$2 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match$2.themeObj;
  var match$3 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var sdkHandleConfirmPayment = match$3.sdkHandleConfirmPayment;
  var match$4 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var paymentType = PaymentTypeContext$OrcaPaymentPage.usePaymentType();
  var confirmPayload = PaymentBody$OrcaPaymentPage.confirmPayloadForSDKButton(sdkHandleConfirmPayment);
  var buttonText;
  buttonText = paymentType === "PaymentMethodsManagement" ? Core__Option.getOr(match$4.sdkHandleSavePayment.buttonText, "Save Card") : (
      label !== undefined ? label : Core__Option.getOr(sdkHandleConfirmPayment.buttonText, match$2.localeString.payNowButton)
    );
  var handleMessage = function ($$event) {
    var json = Utils$OrcaPaymentPage.safeParse(Utils$OrcaPaymentPage.getStringFromJson($$event.data, ""));
    var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
    var submitSuccessfulVal = dict["submitSuccessful"];
    if (submitSuccessfulVal !== undefined && !Core__Option.getOr(Core__JSON.Decode.bool(submitSuccessfulVal), false)) {
      setIsPayNowButtonDisable(function (param) {
            return false;
          });
      return setShowLoader(function (param) {
                  return false;
                });
    }
    
  };
  var onClickHandlerFunc = function (param) {
    if (onClickHandler !== undefined) {
      return onClickHandler();
    }
    
  };
  var handleOnClick = function (param) {
    setIsPayNowButtonDisable(function (param) {
          return true;
        });
    setShowLoader(function (param) {
          return true;
        });
    EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", handleMessage, "onSubmitSuccessful");
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
            "handleSdkConfirm",
            confirmPayload
          ]]);
  };
  return React.createElement("div", {
              className: "flex flex-col gap-1 h-auto w-full items-center"
            }, React.createElement("button", {
                  className: "w-full flex flex-row justify-center items-center",
                  style: {
                    backgroundColor: themeObj.buttonBackgroundColor,
                    border: themeObj.buttonBorderWidth + " solid " + themeObj.buttonBorderColor,
                    cursor: isPayNowButtonDisable ? "not-allowed" : "pointer",
                    height: themeObj.buttonHeight,
                    width: themeObj.buttonWidth,
                    opacity: isPayNowButtonDisable ? "0.6" : "1",
                    borderRadius: themeObj.buttonBorderRadius
                  },
                  disabled: isPayNowButtonDisable,
                  onClick: Core__Option.isNone(onClickHandler) ? handleOnClick : onClickHandlerFunc
                }, React.createElement("span", {
                      id: "button-text",
                      style: {
                        color: themeObj.buttonTextColor,
                        fontSize: themeObj.buttonTextFontSize,
                        fontWeight: themeObj.buttonTextFontWeight
                      }
                    }, match[0] ? React.createElement(PayNowButton$Loader, {}) : buttonText)));
}

var make = PayNowButton;

export {
  Loader ,
  make ,
}
/* react Not a pure module */
